import { useCacheLocal } from "@/hooks/useCacheLocal";
import { createContext, ReactNode, useContext, useState } from "react";

type TContactFilterCache = {
  page?: number | null;
  tab?: string | null;
};

type ContactFilterCacheContextType = {
  contactFilterCache: TContactFilterCache;
  setContactFilterCache: (newFilter: TContactFilterCache) => void;
};

const ContactFilterCacheContext = createContext<ContactFilterCacheContextType | undefined>(undefined);

export const ContactFilterCacheProvider = ({ children }: { children: ReactNode }) => {
  const { getJSON, setJSON } = useCacheLocal("contact-filter");

  const [contactFilterCache, setContactFilter] = useState<TContactFilterCache>({
    ...getJSON(),
  });

  const setContactFilterCache = (newFilter: TContactFilterCache) => {
    setJSON(newFilter);
    setContactFilter(newFilter);
  };

  return <ContactFilterCacheContext.Provider value={{ contactFilterCache, setContactFilterCache }}>{children}</ContactFilterCacheContext.Provider>;
};

export const useContactFilterCache = (): ContactFilterCacheContextType => {
  const context = useContext(ContactFilterCacheContext);
  if (!context) {
    throw new Error("useContactFilterCache must be used within ContactFilterCacheProvider");
  }
  return context;
};
